<template>
    <div id="js-user-wrap" class="container">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="box-card-title">证书维持政策</span>
                <router-link to="/renewal">
                    <el-button size="small" type="primary" class="return-button">返回</el-button>
                </router-link>
                <router-link to="/cpePolicy">
                    <el-button size="small" type="primary" class="return-button">证书维持政策</el-button>
                </router-link>
                <router-link to="/cpeApply">
                    <el-button size="small" type="primary" class="return-button">CPE申报</el-button>
                </router-link>
                <router-link to="/cpeActivity">
                    <el-button size="small" type="primary" class="return-button">CPE近期活动</el-button>
                </router-link>
<!--                <router-link to="/renewal">-->
<!--                    <el-button size="small" type="primary" class="return-button">证书维持</el-button>-->
<!--                </router-link>-->
            </div>

            <div class="ql-editor" v-html="wikiHtml"/>
        </el-card>
    </div>
</template>
<script>

export default {

    data:()=>{
        return {
            wikiHtml:null,
        };
    },
    created() {
        this.getData();
    },

    methods: {
        async getData() { 
            let res = await this.$axios.get('/wiki/policy');
            if (res.code == 200) {
                this.wikiHtml = res.data
            }
        },
    },
    mounted() {

    }
};
</script>


<style scoped>
.tips{
    color:#f01414;
    font-size: 14px;
    margin-top: 7px;
}
.container {
    margin-left: auto;
    margin-right: auto;
    max-width: 1300px;
}
.box-card {
    width: 100%;
    margin-top: 10px;
}
.el-input {
    width: 80%;
}
.return-button {
    float: right;
    margin-left: 20px;
}
@media screen and (max-width: 767px) {
    .el-card {
        box-shadow: none;
        border: none;
    }
}
.ql-editor{
    padding: 0 0 10px 0;
}
</style>
